module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-157.cbe0dcc.woff2";